import { take } from '../../util';
import { z } from 'zod';
export const reportSchema = z.object({
    name: z.string(),
    reportId: z.string(),
});
export const fromGQL = (item) => take(item, 'name', 'reportId');
export const fromGqlCollection = (items) => (items || []).map(item => fromGQL(item));
//# sourceMappingURL=Report.js.map